export default (arr = [], type) => {
  // Try to find element by equal or casting target to integer
  return !arr.find(el => el === type || parseInt(el) === type);
};
